import type { UserDTO } from '@trevize/api/types'

/** Client shape aligned with `userById` / tRPC `auth.me` for drop-in replacement. */
export type AuthMeUser = UserDTO & {
  profile: { locale: string | null; defaultModel: string | null } | null
  workspaces: Array<{
    id: string
    name: string | null
    slug: string
    logo: string | null
    dismissedOnboardingCards: string[]
  }>
}

/** Raw row from {@linkcode queries.auth.me} (flattened related graph). */
type ZeroAuthMeRow = {
  id: string
  name?: string | null
  email?: string | null
  image?: string | null
  createdAt?: number | null
  updatedAt?: number | null
  profile?: { locale?: string | null; defaultModel?: string | null } | null
  memberships?: ReadonlyArray<{
    workspace?: {
      id: string
      name?: string | null
      slug: string
      logo?: string | null
    } | null
    settings?: { dismissedOnboardingCards?: readonly string[] | null } | null
  } | null> | null
}

export function authMeFromZero(row: ZeroAuthMeRow): AuthMeUser {
  const workspaces =
    row.memberships?.flatMap((m) => {
      if (!m?.workspace) {
        return []
      }
      const w = m.workspace
      const dismissed = m.settings?.dismissedOnboardingCards
      return [
        {
          id: w.id,
          name: w.name ?? null,
          slug: w.slug,
          logo: w.logo ?? null,
          dismissedOnboardingCards:
            dismissed === null || dismissed === undefined ? [] : [...dismissed],
        },
      ]
    }) ?? []

  const locale = row.profile?.locale
  const defaultModel = row.profile?.defaultModel

  return {
    id: row.id,
    name: row.name ?? null,
    email: row.email ?? null,
    image: row.image ?? null,
    createdAt: new Date(row.createdAt ?? 0),
    updatedAt: new Date(row.updatedAt ?? 0),
    profile:
      row.profile === null || row.profile === undefined
        ? null
        : { locale: locale ?? null, defaultModel: defaultModel ?? null },
    workspaces,
  }
}
